class addCollapsible {
    constructor(buttonSelector, targetSelector, className) {
        this.button = document.querySelector(buttonSelector);
        this.target = document.querySelector(targetSelector);
        this.className = className;

        this.init();
    }

    init() {
        if (this.button && this.target) {
            this.button.addEventListener("click", () => this.toggleClass());
        }
    }

    toggleClass() {
        this.target.classList.toggle(this.className);
    }
}

new addCollapsible('.toggle-active__actions', '.toggle-active', 'active');

class ProductAddOns {
    constructor(formSelector, addOnSelector) {
        this.form = document.querySelector(formSelector);
        this.addOnSelector = addOnSelector;
        this.addOnItems = [];
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.init();
    }

    init() {
        if (this.form) {
            this.form.addEventListener('submit', (e) => {
                e.preventDefault();
                this.handleAddToCart();
            });
        }
    }

    handleAddToCart() {
        const formData = new FormData(this.form);
        const variantId = formData.get("id");
        const variantQuantity = formData.get("quantity");

        if (!variantId) return;

        const selectedAddOns = Array.from(document.querySelectorAll(this.addOnSelector))
            .filter(input => input.checked)
            .map(input => ({
                id: input.value,
                quantity: 1
            }));        

        const items = [
            { id: variantId, quantity: variantQuantity },
            ...selectedAddOns
        ];

        const configData = {
            items,
            sections: this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [],
            sections_url: window.location.pathname,
        };

        if (this.cart) {
            this.cart.setActiveElement(document.activeElement);
        }

        fetch(`${routes.cart_add_url}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(configData),
        })
        .then((res) => res.json())
        .then((cart) => {            
            CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(cart);
            });
        })
        .catch((err) => {
            console.error('Error add on:', err);
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new ProductAddOns('.product-form form[data-type="add-to-cart-form"]', '.add-on-checkbox input[type="checkbox"]');
});